var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{staticStyle:{"height":"100%","line-height":"100%"},attrs:{"description":"404 找不到页面"}})
}
var staticRenderFns = []

export { render, staticRenderFns }